var map = {
	"./add-circle-center-img.jpg": "./src/assets/img/add-circle-center-img.jpg",
	"./adlogo.jpg": "./src/assets/img/adlogo.jpg",
	"./artwork.jpg": "./src/assets/img/artwork.jpg",
	"./bgnew.jpg": "./src/assets/img/bgnew.jpg",
	"./black1.jpg": "./src/assets/img/black1.jpg",
	"./black2.jpg": "./src/assets/img/black2.jpg",
	"./black3.jpg": "./src/assets/img/black3.jpg",
	"./black_1.jpg": "./src/assets/img/black_1.jpg",
	"./black_2.jpg": "./src/assets/img/black_2.jpg",
	"./black_3.jpg": "./src/assets/img/black_3.jpg",
	"./blue_1.jpg": "./src/assets/img/blue_1.jpg",
	"./blue_2.jpg": "./src/assets/img/blue_2.jpg",
	"./blue_3.jpg": "./src/assets/img/blue_3.jpg",
	"./circle1.jpg": "./src/assets/img/circle1.jpg",
	"./circle2.jpg": "./src/assets/img/circle2.jpg",
	"./circle3.jpg": "./src/assets/img/circle3.jpg",
	"./circle4.jpg": "./src/assets/img/circle4.jpg",
	"./clip-middle-img.jpg": "./src/assets/img/clip-middle-img.jpg",
	"./custom-colr.jpg": "./src/assets/img/custom-colr.jpg",
	"./design-text-view.jpg": "./src/assets/img/design-text-view.jpg",
	"./gold1.jpg": "./src/assets/img/gold1.jpg",
	"./gold2.jpg": "./src/assets/img/gold2.jpg",
	"./gold3.jpg": "./src/assets/img/gold3.jpg",
	"./gold_1.jpg": "./src/assets/img/gold_1.jpg",
	"./gold_2.jpg": "./src/assets/img/gold_2.jpg",
	"./gold_3.jpg": "./src/assets/img/gold_3.jpg",
	"./gray_1.jpg": "./src/assets/img/gray_1.jpg",
	"./gray_2.jpg": "./src/assets/img/gray_2.jpg",
	"./gray_3.jpg": "./src/assets/img/gray_3.jpg",
	"./green.jpg": "./src/assets/img/green.jpg",
	"./green2.jpg": "./src/assets/img/green2.jpg",
	"./green3.jpg": "./src/assets/img/green3.jpg",
	"./grey1.jpg": "./src/assets/img/grey1.jpg",
	"./grey2.jpg": "./src/assets/img/grey2.jpg",
	"./grey3.jpg": "./src/assets/img/grey3.jpg",
	"./lightgreen_1.jpg": "./src/assets/img/lightgreen_1.jpg",
	"./lightgreen_2.jpg": "./src/assets/img/lightgreen_2.jpg",
	"./lightgreen_3.jpg": "./src/assets/img/lightgreen_3.jpg",
	"./logo.jpg": "./src/assets/img/logo.jpg",
	"./mat-desing.jpg": "./src/assets/img/mat-desing.jpg",
	"./matbg.jpg": "./src/assets/img/matbg.jpg",
	"./pimg.jpg": "./src/assets/img/pimg.jpg",
	"./profile.jpg": "./src/assets/img/profile.jpg",
	"./puzzle_mb.jpg": "./src/assets/img/puzzle_mb.jpg",
	"./puzzle_pc.jpg": "./src/assets/img/puzzle_pc.jpg",
	"./rb1.jpg": "./src/assets/img/rb1.jpg",
	"./rb2.jpg": "./src/assets/img/rb2.jpg",
	"./rb3.jpg": "./src/assets/img/rb3.jpg",
	"./red1.jpg": "./src/assets/img/red1.jpg",
	"./red2.jpg": "./src/assets/img/red2.jpg",
	"./red3.jpg": "./src/assets/img/red3.jpg",
	"./red_1.jpg": "./src/assets/img/red_1.jpg",
	"./red_2.jpg": "./src/assets/img/red_2.jpg",
	"./red_3.jpg": "./src/assets/img/red_3.jpg",
	"./rubbercolors/brown-95.jpg": "./src/assets/img/rubbercolors/brown-95.jpg",
	"./rubbercolors/charcoal-gery-95.jpg": "./src/assets/img/rubbercolors/charcoal-gery-95.jpg",
	"./rubbercolors/gery-95.jpg": "./src/assets/img/rubbercolors/gery-95.jpg",
	"./rubbercolors/gery-tan-95.jpg": "./src/assets/img/rubbercolors/gery-tan-95.jpg",
	"./rubbercolors/red-95.jpg": "./src/assets/img/rubbercolors/red-95.jpg",
	"./rubbercolors/tan-95.jpg": "./src/assets/img/rubbercolors/tan-95.jpg",
	"./select-tem.jpg": "./src/assets/img/select-tem.jpg",
	"./template1.jpg": "./src/assets/img/template1.jpg",
	"./template10.jpg": "./src/assets/img/template10.jpg",
	"./template11.jpg": "./src/assets/img/template11.jpg",
	"./template12.jpg": "./src/assets/img/template12.jpg",
	"./template13.jpg": "./src/assets/img/template13.jpg",
	"./template14.jpg": "./src/assets/img/template14.jpg",
	"./template15.jpg": "./src/assets/img/template15.jpg",
	"./template2.jpg": "./src/assets/img/template2.jpg",
	"./template3.jpg": "./src/assets/img/template3.jpg",
	"./template4.jpg": "./src/assets/img/template4.jpg",
	"./template5.jpg": "./src/assets/img/template5.jpg",
	"./template6.jpg": "./src/assets/img/template6.jpg",
	"./template7.jpg": "./src/assets/img/template7.jpg",
	"./template8.jpg": "./src/assets/img/template8.jpg",
	"./template9.jpg": "./src/assets/img/template9.jpg",
	"./turf_mb.jpg": "./src/assets/img/turf_mb.jpg",
	"./turf_pc.jpg": "./src/assets/img/turf_pc.jpg",
	"./upimg.jpg": "./src/assets/img/upimg.jpg",
	"./upld-middl-img.jpg": "./src/assets/img/upld-middl-img.jpg",
	"./upmats.jpg": "./src/assets/img/upmats.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.jpg$";